import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

export default ({ initialState, rootReducer, api }) => {
  let createStoreWithMiddleware;

  if (process.env.ENV !== 'production') {
    const { createLogger } = require('redux-logger');

    createStoreWithMiddleware = applyMiddleware(
      thunk.withExtraArgument(api),
      createLogger({}),
    )(createStore);
  } else {
    createStoreWithMiddleware = applyMiddleware(thunk.withExtraArgument(api))(
      createStore,
    );
  }

  const store = createStoreWithMiddleware(rootReducer, initialState);

  return store;
};
